module.exports = __webpack_public_path__ + "img/GBM1_Mast.3ab6d6ab.png";